import { ContentsFileServiceApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import useModal from 'hooks/useModal';

function useUpload() {
  const { handleAlert } = useModal();

  const queryClient = useQueryClient();
  const { mutateAsync } = useAuthMutation(ContentsFileServiceApi.upload, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys(KEY).all,
      });
    },
  });

  const handleUpload = async (id: string, file: File) => {
    const validTypes = ['image/png', 'image/jpeg']; // jpeg은 MIME 타입이 image/jpeg
    const maxSizeInBytes = 1 * 1024 * 1024; // 1MB = 1024KB

    if (!validTypes.includes(file.type)) {
      handleAlert('지원하지 않는 파일 형식입니다.');
      return;
    }

    if (file.size > maxSizeInBytes) {
      handleAlert('파일 크기는 1MB 이하여야 합니다.');
      return;
    }

    return await mutateAsync({ id, file });
  };

  return { handleUpload };
}

export default useUpload;
